import { HttpClient } from '@angular/common/http';
import { IpWhiteListFullModel } from '@models/IpWhiteList';
import { Observable, Subject } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';

export class IpWhiteListService {
  private data$ = new Subject<IpWhiteListFullModel>();
  public ips$ = this.data$.pipe(
    map((data) => ({ whiteLists: data?.whiteLists || [], restrictionByIpsOn: !!data?.restrictionByIpsOn }) as IpWhiteListFullModel),
    startWith<IpWhiteListFullModel>({ whiteLists: [], restrictionByIpsOn: false }),
    shareReplay()
  );

  constructor(private http: HttpClient) {}

  public get(): Observable<IpWhiteListFullModel> {
    this.http.get<IpWhiteListFullModel>(`Admin/IPWhiteLists/GetOwnerIPWhiteLists`).subscribe((model) => this.data$.next(model));

    return this.ips$;
  }

  public update(model: Partial<IpWhiteListFullModel> & { restrictionOn: boolean }): Observable<boolean> {
    return this.http.post<boolean>(`Admin/IPWhiteLists/SaveChanges`, model);
  }

  public getCurrentIp(): Observable<string> {
    return this.http.get<any>('Admin/IPWhiteLists/GetProvidersCurrentIP').pipe(map((data) => data?.currentIp));
  }
}
